import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleHeader from './components/ArticleHeader';
import ArticleContent from './components/ArticleContent';
import CommentSection from './components/CommentSection';
import RelatedArticles from './components/RelatedArticles';
import { articleDetail } from '@/mocks/article';

export default function Article() {
  const { slug } = useParams<{ slug: string }>();

  const breadcrumbItems = [
    { label: '首页', href: '/' },
    { label: articleDetail.category, href: `/category/${articleDetail.categorySlug}` },
    { label: articleDetail.title },
  ];

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Article',
            headline: articleDetail.title,
            description: articleDetail.content[0]?.text || '',
            image: articleDetail.image,
            author: {
              '@type': 'Person',
              name: articleDetail.author,
            },
            datePublished: '2026-07-07T06:30:00+08:00',
            publisher: {
              '@type': 'Organization',
              name: '吃瓜网站线路一',
            },
            url: `https://www.chigua.com/article/${slug}`,
            isPartOf: {
              '@type': 'WebSite',
              name: '吃瓜网站线路一',
              url: 'https://www.chigua.com/',
            },
          }),
        }}
      />
      <Navbar />
      <main>
        <div className="bg-background-50">
          <Breadcrumb items={breadcrumbItems} />
        </div>
        <ArticleHeader />
        <ArticleContent />
        <CommentSection />
        <RelatedArticles />
        <section className="relative w-full py-16 md:py-20 overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20with%20deep%20crimson%20and%20dark%20amber%20flowing%20waves%2C%20luxurious%20dark%20red%20texture%20with%20golden%20highlights%2C%20smooth%20elegant%20color%20transition%2C%20modern%20artistic%20background%2C%20pure%20abstract%2C%20soft%20motion%20blur%2C%20rich%20warm%20tones%2C%20professional%20cinematic%20look&width=1920&height=600&seq=article-cta-bg&orientation=landscape"
              alt=""
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/35 to-black/50"></div>
          <div className="relative z-10 text-center px-4">
            <h2 className="text-2xl md:text-4xl font-bold text-white font-heading mb-4">
              还没吃够？继续看更多
            </h2>
            <p className="text-sm md:text-base text-white/60 mb-8 max-w-md mx-auto">
              每天都有新的大瓜爆料，千万不要错过
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/"
                className="inline-flex items-center gap-2 bg-white text-foreground-950 px-8 py-3 rounded-full text-sm font-semibold whitespace-nowrap hover:bg-white/90 transition-all duration-200 hover:scale-105 cursor-pointer"
              >
                返回首页
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-home-4-line text-sm"></i>
                </span>
              </Link>
              <Link
                to={`/category/${articleDetail.categorySlug}`}
                className="inline-flex items-center gap-2 bg-white/20 text-white px-8 py-3 rounded-full text-sm font-semibold whitespace-nowrap hover:bg-white/30 transition-all duration-200 cursor-pointer"
              >
                更多{articleDetail.category}
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}